import React from 'react';
import { motion } from 'framer-motion';
export function Closing() {
  return <section className="py-24 bg-white" data-id="element-10">
      <div className="max-w-6xl mx-auto px-6" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-slate-950 to-slate-900 rounded-2xl p-12 text-center" data-id="element-12">
          <h3 className="font-editorial text-3xl font-bold text-white mb-4" data-id="element-13">
            Next Steps
          </h3>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto" data-id="element-14">
            Refine speaker selection, finalize topic structure, and begin
            production planning for the 6-video Master-Class series
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center text-sm text-slate-500" data-id="element-15">
          <p data-id="element-16">
            Prepared for Leo Pharma •{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
        </motion.div>
      </div>
    </section>;
}